import { HttpErrorResponse } from '@angular/common/http';
import filter from 'lodash-es/filter';
import some from 'lodash-es/some';
import { v4 as v4uuid } from 'uuid';
import { ConfigService } from '../config/config.service';
import { WindowService } from '../window/window.service';
import { Severity } from './flash-message.model';
var FlashMessagesService = /** @class */ (function () {
    function FlashMessagesService(configService, windowService) {
        this.configService = configService;
        this.windowService = windowService;
    }
    Object.defineProperty(FlashMessagesService.prototype, "flashMessages", {
        // noinspection JSMethodCanBeStatic
        get: function () {
            return FlashMessagesService.flashMessages;
        },
        enumerable: true,
        configurable: true
    });
    FlashMessagesService.prototype.addMessage = function (severity, message, preface) {
        if (preface === void 0) { preface = ''; }
        var flashMessage = {
            id: v4uuid(),
            text: message,
            preface: preface,
            severity: severity
        };
        this.windowService.scrollToTop();
        FlashMessagesService.flashMessages = this.flashMessages.concat(flashMessage);
        return flashMessage.id;
    };
    FlashMessagesService.prototype.addMessageFor = function (subject) {
        if (subject instanceof HttpErrorResponse) {
            var id = '';
            var message = '';
            if (subject.status === 400) {
                message = subject.error.message;
                if (subject.error.modelState != null) {
                    message = subject.error.modelState.request[0];
                }
                var preface = this.configService.config.productName + " API Validation Failed:";
                id = this.addMessage(Severity.Danger, message, preface);
            }
            else {
                // Assume it's an unhandled .NET exception.
                message = subject.message;
                // Special case for unhandled .NET exceptions.
                if (subject.error.message) {
                    var ex = this.cleanExceptionMessage(subject.error.exceptionMessage);
                    message = subject.error.exceptionType + ": " + subject.error.message + " " + ex;
                    var innerException = subject.error.innerException;
                    while (innerException) {
                        message += " " + this.cleanExceptionMessage(innerException.exceptionMessage);
                        innerException = innerException.innerException;
                    }
                }
                var preface = this.configService.config.productName + " API Error:";
                id = this.addMessage(Severity.Danger, message, preface);
            }
            return id;
        }
        else {
            throw subject;
        }
    };
    FlashMessagesService.prototype.clear = function (id) {
        if (id) {
            FlashMessagesService.flashMessages = filter(this.flashMessages, function (message) {
                return message.id !== id;
            });
        }
    };
    // noinspection JSMethodCanBeStatic
    FlashMessagesService.prototype.clearAll = function () {
        FlashMessagesService.flashMessages = [];
    };
    FlashMessagesService.prototype.hasMessagesOf = function (severity) {
        return some(this.flashMessages, this.whichHave(severity));
    };
    FlashMessagesService.prototype.messagesFor = function (severity) {
        return filter(this.flashMessages, this.whichHave(severity));
    };
    // noinspection JSMethodCanBeStatic
    FlashMessagesService.prototype.cleanExceptionMessage = function (exceptionMessage) {
        if (exceptionMessage.endsWith('.')) {
            return exceptionMessage;
        }
        return exceptionMessage + ".";
    };
    FlashMessagesService.prototype.whichHave = function (severity) {
        return function (message) {
            return message.severity === severity;
        };
    };
    FlashMessagesService.flashMessages = [];
    return FlashMessagesService;
}());
export { FlashMessagesService };
